import { useRestQuery } from '@/lib/hook/tanstackQuery'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'
import { Menus } from '@/src/types/api-types'

// Reproduit apollo/server/resolvers/CMS/getMenus.ts :
// GET menus, ou GET menus?usergroups=<csv> quand des usergroups sont fournis.
export const useMenus = (usergroups: (string | number)[] = []) => {
  const query = useRestQuery<Menus[]>({
    ...ApiQueryEndpoint.CMS.GET_MENUS,
    queryKey: ['menus', usergroups],
    queriesParams: usergroups.length ? { usergroups: usergroups.join(',') } : undefined,
    staleTime: 1000 * 60 * 5,
  })

  return {
    menus: query.data ?? [],
    isLoading: query.isLoading,
  }
}
